/* import __COLOCATED_TEMPLATE__ from './banner-web-chrome.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();